"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3973],{

/***/ 493973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ AuthPopUp; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(147568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(629815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(197582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(811163);
// EXTERNAL MODULE: ./src/utils/constants/images.js
var constants_images = __webpack_require__(284320);
// EXTERNAL MODULE: ./src/components/Common/Modal/index.jsx
var Modal = __webpack_require__(672651);
// EXTERNAL MODULE: ./src/components/Common/Toast/index.jsx
var Toast = __webpack_require__(40804);
// EXTERNAL MODULE: ./src/redux/actions/user.js
var actions_user = __webpack_require__(656173);
// EXTERNAL MODULE: ./src/redux/actions/storeInfo.js
var actions_storeInfo = __webpack_require__(117321);
// EXTERNAL MODULE: ./src/redux/actions/auth.js
var auth = __webpack_require__(368060);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/Button/index.js + 1 modules
var Button = __webpack_require__(952479);
// EXTERNAL MODULE: ./src/utils/localStorageFunctions.js
var localStorageFunctions = __webpack_require__(174943);
// EXTERNAL MODULE: ./src/utils/getWindowDimension.js
var getWindowDimension = __webpack_require__(37110);
// EXTERNAL MODULE: ./src/redux/store/index.js + 44 modules
var store = __webpack_require__(167261);
;// CONCATENATED MODULE: ./src/utils/getRequestNounce.js

/**
 * function returns a unique string composed of
 * two times timeStamp and storeID separated by a '-'
 * used in truecaller deeplink to get unique reques id
 * @return {String}
 */ function getRequestNounce() {
    var timeStamp = new Date().getTime();
    var storeId = store/* default.getState */.Z.getState().storeReducer.store.store_id;
    if (!storeId) return "";
    var requestNounce = timeStamp.toString() + timeStamp.toString() + "-" + storeId.toString();
    return requestNounce;
}

// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./src/utils/operatingSystem.ts
var operatingSystem = __webpack_require__(755311);
;// CONCATENATED MODULE: ./src/components/DesignSystem/AuthPopUp/Truecaller.js






/**
 * function Contains a Deeplink that invokes truecaller verification modal from
 * truecaller app (works for android alone)
 *
 * function invokes on onFocus is triggered from authentication Modal. If Truecaller app is
 * is Present it invokes a verfication modal from truecaller app.
 *
 * If modal successfully opens broswer document will lose focus and we start the polling process.
 * else OTP verification flows continues.
 *
 * authication api is called every 3 seconds after truecaller popup opens till its closed.
 *
 *     countForPollCall == Max number of api calls allowed to authenticate user in a session.
 *     requestNonce == Unique-id associated with user login attempt.
 *
 *     TRUECALLER_PARTNER_KEY == Dotpe partner key for truecaller-verification.Value acquired
 *                               from environment variable from .env file.
 *
 *      Popup == contains truecaller deeplink. Params are passed that dictate UI of truecaller popup
 *              along with unique-id , partnerKey.
 *
 *      Corrected_theme_color == "#" removed string passed as params to deeplink for button color.
 *
 *      setCountForPollCall == sets api call counter.
 *      decrementCountForPollCall == decrease the counter for Pollcall by 1
 *      CheckCountForPollcall == checks api call limit reached in a session.
 *
 *      hash character '#' in deeplink doesnt work.
 */ var countForPollCall = 0;
function truecallerPopup() {
    var checkCountForPollCall = function checkCountForPollCall() {
        if (countForPollCall === 0) return false;
        return true;
    };
    var setCountForPollCall = function setCountForPollCall() {
        countForPollCall = 5;
    };
    var decrementCountForPollCall = function decrementCountForPollCall() {
        countForPollCall--;
    };
    var ref, ref1, ref2, ref3, ref4;
    var mobileOsName = (0,operatingSystem/* getMobileOperatingSystem */.HG)();
    var theme_color = ((ref = store/* default.getState */.Z.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.storeReducer) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.store) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.theme) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.colors) === null || ref4 === void 0 ? void 0 : ref4.primary_color) || "#000000";
    var isTruecallerPresent = store/* default.getState */.Z.getState().userReducer.truecallerPresent;
    var corrected_theme_color = theme_color.slice(1, theme_color.length);
    if (true) {
        var requestNonce = getRequestNounce();
        setCountForPollCall();
        var TRUECALLER_PARTNER_KEY = "5TsHnf245d1e79c404ca4ba727dd9c47eb629";
        var popup = "truecallersdk://truesdk/web_verify?type=btmsheet&requestNonce=".concat(requestNonce, "&partnerKey=").concat(TRUECALLER_PARTNER_KEY, "&partnerName=Digital Showroom&lang=en&loginPrefix=getstarted&loginSuffix=verifymobile&ctaPrefix=use&ctaColor=%23").concat(corrected_theme_color, "&ctaTextColor=%23ffffff&btnShape=round&skipOption=useanothernum");
        if (mobileOsName !== "iOS" && !isTruecallerPresent) window.location.href = popup;
        setTimeout(function() {
            if (!document.hasFocus()) {
                store/* default.dispatch */.Z.dispatch((0,actions_user/* truecallerPresent */.BT)());
                var pollIntervalId = setInterval(function() {
                    if (checkCountForPollCall() && !document.hasFocus()) {
                        store/* default.dispatch */.Z.dispatch((0,auth/* authTruecallerDetails */.B5)(requestNonce));
                        decrementCountForPollCall();
                    } else if (checkCountForPollCall() && document.hasFocus()) {
                        store/* default.dispatch */.Z.dispatch((0,auth/* authTruecallerDetails */.B5)(requestNonce));
                        clearInterval(pollIntervalId);
                    } else {
                        clearInterval(pollIntervalId);
                        (0,Toast/* toastNotifyError */.Lu)(constants/* TRUECALLER_SESSION_ERROR */.Ev);
                    }
                }, 3000);
            }
        }, 1000);
    }
}
/* harmony default export */ var Truecaller = (truecallerPopup);

// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
// EXTERNAL MODULE: ./node_modules/react-otp-input/lib/index.js
var lib = __webpack_require__(671470);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_array.mjs
var _to_array = __webpack_require__(759637);
// EXTERNAL MODULE: ./node_modules/firebase/auth/dist/esm/index.esm.js + 1 modules
var index_esm = __webpack_require__(191259);
// EXTERNAL MODULE: ./node_modules/firebase/app/dist/esm/index.esm.js
var esm_index_esm = __webpack_require__(983977);
;// CONCATENATED MODULE: ./src/config/firebase.js
var firebaseConfig = {
    apiKey: "AIzaSyBfwMOR-NnzzSfRmocjc39EImHGN7VLXjk",
    authDomain: "new-digitaldukaan.firebaseapp.com",
    databaseURL: "https://new-digitaldukaan.firebaseio.com",
    projectId: "new-digitaldukaan",
    storageBucket: "new-digitaldukaan.appspot.com",
    messagingSenderId: "474446874433",
    appId: "1:474446874433:web:6d883afb77c191ca63c3c0",
    measurementId: "G-SJWXPQ8T9V"
};

;// CONCATENATED MODULE: ./src/utils/gmailLogin.js





// Initialize Firebase
(0,esm_index_esm/* initializeApp */.ZF)(firebaseConfig);
var provider = new index_esm/* GoogleAuthProvider */.hJ();
var gmailLogin_auth = (0,index_esm/* getAuth */.v0)();
var googleSignIn = function() {
    return (0,index_esm/* signInWithPopup */.rh)(gmailLogin_auth, provider).then(function(result) {
        var ref;
        // This gives you a Google Access Token. You can use it to access the Google API.
        var user = result.user;
        var ref1 = (0,_to_array/* default */.Z)((user === null || user === void 0 ? void 0 : (ref = user.displayName) === null || ref === void 0 ? void 0 : ref.split(" ")) || [
            "",
            ""
        ]), firstName = ref1[0], lastName = ref1.slice(1);
        var payload = {
            email_id: user.email,
            first_name: firstName,
            last_name: lastName.join(" "),
            sign_in_id: user.uid,
            photo: user.photoURL
        };
        // auth.currentUser.getIdToken(true);
        googleSignOut();
        return payload;
    }).catch(function(error) {
        // Handle Errors here.
        //   const credential = GoogleAuthProvider.credentialFromError(error);
        (0,Toast/* toastNotifyError */.Lu)(error);
    });
};
var googleSignOut = function() {
    (0,index_esm/* signOut */.w7)(gmailLogin_auth);
};

// EXTERNAL MODULE: ./src/hooks/useAuthenticate.ts
var useAuthenticate = __webpack_require__(807362);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
;// CONCATENATED MODULE: ./src/components/DesignSystem/AuthPopUp/index.js























var MAXIMUM_VERIFY_OTP_TRIES_ALLOWED = 3;
var AuthModal = function(props) {
    var disableSendOtpAfterOneClick = function disableSendOtpAfterOneClick() {
        setState(function(data) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                disableSendOtpAfterOneClick: true
            });
        });
        setTimeout(function() {
            setState(function(data) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                    disableSendOtpAfterOneClick: false
                });
            });
        }, 1000);
    };
    var _requestConfigArgs = function _requestConfigArgs() {
        var isEmailLogin = !state.isLoginByMobileNumber;
        var contact = isEmailLogin ? state.email : state.phone;
        return [
            verifyOtpCallback,
            true,
            contact,
            isEmailLogin,
            !!props.redirection
        ];
    };
    var activeCloseFunction = function activeCloseFunction() {
        if (props.isFromCart) return props.handleOnCloseButton();
        else return props.toggleModal();
    };
    var width = (0,getWindowDimension/* default */.Z)().width;
    var router = (0,next_router.useRouter)();
    var ref = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
        return {
            storeInfo: state.storeReducer.store,
            emailLoginFeatureStatus: state === null || state === void 0 ? void 0 : (ref = state.storeReducer) === null || ref === void 0 ? void 0 : (ref1 = ref.store) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.services) === null || ref2 === void 0 ? void 0 : ref2.email_login,
            indianMobileLoginFeatureStatus: state === null || state === void 0 ? void 0 : (ref3 = state.storeReducer) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.store) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.services) === null || ref5 === void 0 ? void 0 : ref5.indian_mobile_login,
            user: state.userReducer,
            termsAndConditionsFlag: state === null || state === void 0 ? void 0 : (ref6 = state.storeReducer) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.store) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.services) === null || ref8 === void 0 ? void 0 : ref8.terms_and_conditions_flag
        };
    }), storeInfo = ref.storeInfo, emailLoginFeatureStatus = ref.emailLoginFeatureStatus, indianMobileLoginFeatureStatus = ref.indianMobileLoginFeatureStatus, user = ref.user, termsAndConditionsFlag = ref.termsAndConditionsFlag;
    var finalShowWhatsappCheckbox = termsAndConditionsFlag === 1;
    var handleTermsAndConditionsClick = function(e) {
        var ref;
        e.preventDefault();
        var storeData = storeInfo;
        var targetUrl = (0,routes.getRoute)(routes.PATH.STORE_POLICIES, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain);
        if (targetUrl) {
            window.open("".concat(targetUrl, "?page_type=1"), "_blank", "noopener,noreferrer");
        } else {
            console.error("Invalid target URL for Terms & Conditions");
        }
    };
    var ref1 = (0,useAuthenticate/* default */.Z)(59), otp = ref1.otp, isOtpSent = ref1.isOtpSent, timeLeft = ref1.timeLeft, invalidOtp = ref1.invalidOtp, setOtp = ref1.setOtp, setIsOtpSent = ref1.setIsOtpSent, setInvalidOtp = ref1.setInvalidOtp, sendOtp = ref1.sendOtp, verifyOtp = ref1.verifyOtp;
    var dispatch = (0,es/* useDispatch */.I0)();
    var verifyOtpTries = (0,react.useRef)(0);
    var ref2 = (0,react.useState)({
        phone: "",
        email: "",
        currentDeviceWidth: 0,
        isLoginByMobileNumber: true,
        disableSendOtpAfterOneClick: false,
        disableVerifyOtpAfterOneClick: false,
        whatsappConsent: false
    }), state = ref2[0], setState = ref2[1];
    var canVerifyOtp = isOtpSent && !invalidOtp && otp.length === 4;
    (0,react.useEffect)(function() {
        if (indianMobileLoginFeatureStatus === 0) {
            toggleCurrentLoginType();
        }
    }, [
        indianMobileLoginFeatureStatus
    ]);
    (0,react.useEffect)(function() {
        if (props.isVisible) {
            document.getElementsByTagName("body")[0].style.overflowY = "hidden";
        } else {
            document.getElementsByTagName("body")[0].style.overflowY = "scroll";
        }
    }, [
        props.isVisible
    ]);
    (0,react.useEffect)(function() {
        if (props === null || props === void 0 ? void 0 : props.isPhoneNumber) {
            var phone = (0,localStorageFunctions/* getLeadData */.X5)();
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    phone: phone
                });
            });
            sendOtp(phone, false);
        }
        dispatch((0,actions_user/* truecallerAbsent */.eu)());
    }, []);
    (0,react.useEffect)(function() {
        if (user === null || user === void 0 ? void 0 : user.isLogin) {
            props.toggleModal();
        }
    }, [
        user
    ]);
    (0,react.useEffect)(function() {
        if (props.isVisible && props.sendOTPBeforeHand && props.prefilledPhone) {
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    phone: props.prefilledPhone
                });
            });
            setPhoneNumber(props.prefilledPhone);
        }
    }, [
        props.isVisible,
        props.prefilledPhone
    ]);
    (0,react.useEffect)(function() {
        setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                currentDeviceWidth: width
            });
        });
    }, [
        width
    ]);
    var getRegexByType = function(type) {
        switch(type){
            case "email":
                return /[^\w\@\-\.]/g;
            case "alpha_numeric":
                return /[^\w/]/gi;
            case "alpha_space":
                return /[^a-z ]/gi;
            case "address":
                return /[^\w\s\-\,]/gi;
            default:
                return /[^\d]/gi;
        }
    };
    var handleInputChange = function(key, value, validationType, minLength, maxLength) {
        if (value.length > maxLength) value = value.substring(0, maxLength);
        value = value.replace(getRegexByType(validationType), "");
        if (!isNaN(value) || key === "email") {
            switch(key){
                case "phone":
                    {
                        setState(function(state) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                                phone: value
                            });
                        });
                        break;
                    }
                case "email":
                    {
                        setState(function(state) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                                email: value
                            });
                        });
                        break;
                    }
                case "otp":
                    {
                        invalidOtp && setInvalidOtp(false);
                        setOtp(value);
                        break;
                    }
                default:
                    {
                        console.log("Not a valid key!");
                        break;
                    }
            }
        }
    };
    var setPhoneNumber = function(phoneNo) {
        var phoneReg = /(6|7|8|9)\d{9}/;
        var phone = state.phone || phoneNo;
        if (phone && phone.length === 10 && phone.match(phoneReg)) {
            sendOtp(phone, false);
            disableSendOtpAfterOneClick();
        } else {
            (0,Toast/* toastNotifyError */.Lu)("Invalid Phone Number!");
        }
    };
    var setEmailId = function(emailId) {
        var email = emailId || state.email;
        if (email && email.match(constants/* EMAIL_REGEX */.CU)) {
            sendOtp(email, true, _requestConfigArgs());
            disableSendOtpAfterOneClick();
        } else {
            (0,Toast/* toastNotifyError */.Lu)("Invalid Email ID!");
        }
    };
    var resendOTP = function() {
        var isLoginByEmail = !state.isLoginByMobileNumber;
        var contact = isLoginByEmail ? state.email : state.phone;
        sendOtp(contact, isLoginByEmail, _requestConfigArgs());
    };
    var verifyOtpCallback = function(status) {
        if (!status) {
            verifyOtpTries.current = verifyOtpTries.current + 1;
            if (verifyOtpTries.current === MAXIMUM_VERIFY_OTP_TRIES_ALLOWED) {
                verifyOtpTries.current = 0;
                toggleOTPsent();
            } else setInvalidOtp(true);
        } else {
            var ref;
            dispatch((0,actions_storeInfo/* getB2bRfqInputFields */.f2)());
            props === null || props === void 0 ? void 0 : (ref = props.afterOtpVerifyCallback) === null || ref === void 0 ? void 0 : ref.call(props);
        }
        setState(function(data) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                disableVerifyOtpAfterOneClick: false
            });
        });
    };
    var submitVerifyOTP = function() {
        if (otp.length === 4) {
            verifyOtp.apply(void 0, (0,_to_consumable_array/* default */.Z)(_requestConfigArgs()));
            setState(function(data) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                    disableVerifyOtpAfterOneClick: true
                });
            });
        } else {
            (0,Toast/* toastNotifyError */.Lu)("Please enter valid OTP");
        }
    };
    var signIn = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var gmailAccountData, data, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            googleSignIn()
                        ];
                    case 1:
                        gmailAccountData = _state.sent();
                        data = {
                            email: gmailAccountData.email_id
                        };
                        dispatch((0,auth/* loginWithGmail */.P9)(data, router, props.redirection ? true : false));
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        (0,Toast/* toastNotifyError */.Lu)(err);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function signIn() {
            return _ref.apply(this, arguments);
        };
    }();
    var toggleOTPsent = function() {
        setInvalidOtp(false);
        setIsOtpSent(!isOtpSent);
    };
    var toggleCurrentLoginType = function() {
        setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                phone: "",
                email: "",
                isLoginByMobileNumber: !state.isLoginByMobileNumber
            });
        });
        isOtpSent && setIsOtpSent(false);
        invalidOtp && setInvalidOtp(false);
        otp && setOtp("");
    };
    var isMobileInputInvalid = state.isLoginByMobileNumber && (state.phone.length < 10 || state.disableSendOtpAfterOneClick);
    var isConsentRequired = finalShowWhatsappCheckbox && state.isLoginByMobileNumber;
    var isConsentMissing = isConsentRequired && !state.whatsappConsent;
    var finalIsMobileSendOtpDisabled = isMobileInputInvalid || isConsentMissing;
    var formObject = state.isLoginByMobileNumber ? {
        preOTP: {
            labelText: "Mobile Number",
            inputType: "number",
            inputValue: state.phone,
            inputPlaceholder: "Enter your Mobile Number",
            inputChangeHandler: function(e) {
                return handleInputChange("phone", e.target.value.replace(/[^0-9]/g, ""), "alpha_numeric", 1, 10);
            },
            buttonBackground: finalIsMobileSendOtpDisabled ? "#00000033" : "#2F80ED",
            isButtonDisable: finalIsMobileSendOtpDisabled,
            clickHandler: setPhoneNumber
        },
        duringOTP: {
            contact: state.phone,
            editIcon: "/assets/images/Edit.svg",
            editContactText: "Edit number",
            handleInputChange: function(otp) {
                return handleInputChange("otp", otp.replace(/[^0-9]/g, ""), "alpha_numeric", 1, 4);
            },
            inputValue: otp,
            resendOTP: resendOTP,
            buttonBackground: canVerifyOtp && !state.disableVerifyOtpAfterOneClick ? "#2F80ED" : "#00000033",
            isButtonDisable: !canVerifyOtp || state.disableVerifyOtpAfterOneClick,
            submitVerifyOTP: submitVerifyOTP,
            toggleOTPsent: toggleOTPsent
        },
        toggleLoginButtonIcon: "/assets/images/email-black-white.svg",
        toggleLoginButtonText: "Login with Email ID"
    } : {
        preOTP: {
            labelText: "Email ID",
            inputType: "email",
            inputValue: state.email,
            inputPlaceholder: "Enter your Email ID",
            inputChangeHandler: function(e) {
                return handleInputChange("email", e.target.value, "email", 1, 320);
            },
            buttonBackground: state.email.match(constants/* EMAIL_REGEX */.CU) && !state.disableSendOtpAfterOneClick ? "#2F80ED" : "#00000033",
            isButtonDisable: !state.email.match(constants/* EMAIL_REGEX */.CU) || state.disableSendOtpAfterOneClick,
            clickHandler: setEmailId
        },
        duringOTP: {
            contact: state.email,
            editIcon: "/assets/images/Edit.svg",
            editContactText: "Edit email",
            toggleOTPsent: toggleOTPsent,
            inputValue: otp,
            handleInputChange: function(otp) {
                return handleInputChange("otp", otp.replace(/[^0-9]/g, ""), "alpha_numeric", 1, 4);
            },
            resendOTP: resendOTP,
            isButtonDisable: !canVerifyOtp || state.disableVerifyOtpAfterOneClick,
            buttonBackground: canVerifyOtp && !state.disableVerifyOtpAfterOneClick ? "#2F80ED" : "#00000033",
            submitVerifyOTP: submitVerifyOTP
        },
        toggleLoginButtonIcon: "/assets/images/phone-blue-outline.svg",
        toggleLoginButtonText: "Login with Mobile Number"
    };
    return state.currentDeviceWidth < 766 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PremiumMobileAuth, (0,_object_spread/* default */.Z)({
        OTPsent: isOtpSent,
        invalidOtp: invalidOtp,
        timer: timeLeft,
        storeInfo: storeInfo,
        activeCloseFunction: activeCloseFunction,
        indianMobileLoginFeatureStatus: indianMobileLoginFeatureStatus,
        emailLoginFeatureStatus: emailLoginFeatureStatus,
        isLoginByMobileNumber: state.isLoginByMobileNumber,
        toggleCurrentLoginType: toggleCurrentLoginType,
        formObject: formObject,
        signIn: signIn,
        whatsappConsent: state.whatsappConsent,
        setWhatsappConsent: function(value) {
            return setState(function(s) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, s), {
                    whatsappConsent: value
                });
            });
        },
        showWhatsappCheckbox: finalShowWhatsappCheckbox,
        handleTermsAndConditionsClick: handleTermsAndConditionsClick
    }, props)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PremiumDesktopAuth, (0,_object_spread/* default */.Z)({
        OTPsent: isOtpSent,
        invalidOtp: invalidOtp,
        timer: timeLeft,
        storeInfo: storeInfo,
        activeCloseFunction: activeCloseFunction,
        indianMobileLoginFeatureStatus: indianMobileLoginFeatureStatus,
        emailLoginFeatureStatus: emailLoginFeatureStatus,
        isLoginByMobileNumber: state.isLoginByMobileNumber,
        toggleCurrentLoginType: toggleCurrentLoginType,
        formObject: formObject,
        signIn: signIn,
        whatsappConsent: state.whatsappConsent,
        setWhatsappConsent: function(value) {
            return setState(function(s) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, s), {
                    whatsappConsent: value
                });
            });
        },
        showWhatsappCheckbox: finalShowWhatsappCheckbox,
        handleTermsAndConditionsClick: handleTermsAndConditionsClick
    }, props));
};
var PremiumMobileAuth = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var formObject = props.formObject, handleTermsAndConditionsClick = props.handleTermsAndConditionsClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        visible: props.isVisible,
        className: "bottom-modal margin-top-modal-0",
        animation: "slideUp",
        onClose: props.toggleModal,
        closeMaskOnClick: !props.sendOTPBeforeHand ? props.isFromCart ? false : true : false,
        customStyles: {
            padding: "24px 20px 80px 20px",
            maxHeight: "80%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-column premium-auth-modal-wrap",
            children: [
                props.OTPsent ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        !props.sendOTPBeforeHand ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-end closeicon",
                            onClick: props.activeCloseFunction,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                loading: "lazy",
                                src: "https://cdn.dotpe.in/longtail/themes/8073865/9sE359Sh.webp",
                                alt: "cancel"
                            })
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-column",
                            style: {
                                gap: "32px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-column login-otp-number-wrap",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "f20px fw7 otp-header",
                                            children: " OTP sent to "
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex justify-between flex-wrap items-center contact-edit-btn-wrapper",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "f24px fw7",
                                                    children: formObject.duringOTP.contact
                                                }),
                                                !props.prefilledPhone ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex pointer edit-btn",
                                                    onClick: function() {
                                                        return formObject.duringOTP.toggleOTPsent();
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: formObject.duringOTP.editIcon,
                                                            alt: "edit",
                                                            height: "18px",
                                                            width: "18px"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "f16px fw6",
                                                            children: formObject.duringOTP.editContactText
                                                        })
                                                    ]
                                                }) : null
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "otp-form-group form-group flex flex-column",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-column input-resend-wrapper",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-column label-input-wrapper",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        className: "f14px fw6",
                                                        children: "Enter OTP"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                                        value: formObject.duringOTP.inputValue,
                                                        onChange: formObject.duringOTP.handleInputChange,
                                                        numInputs: 4,
                                                        separator: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: " "
                                                        }),
                                                        containerStyle: {
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            alignItems: "flex-start",
                                                            gap: "16px"
                                                        },
                                                        shouldAutoFocus: true,
                                                        inputStyle: {
                                                            display: "flex",
                                                            width: "100%",
                                                            height: "100%",
                                                            padding: "6px 12px",
                                                            gap: "10px",
                                                            borderRadius: 6,
                                                            flex: "1 0 0",
                                                            border: "1px solid #E9E9E9"
                                                        },
                                                        isInputNum: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex justify-between message-resend-wrapper",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        style: props.invalidOtp ? {
                                                            color: "red"
                                                        } : {
                                                            visibility: "hidden"
                                                        },
                                                        children: "Invalid OTP"
                                                    }),
                                                    props.timer ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "timer db f16px fw4",
                                                        children: [
                                                            "Resend in ",
                                                            "0:".concat(props.timer)
                                                        ]
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex justify-end f12px",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "blue fw6 f16px pointer",
                                                            onClick: formObject.duringOTP.resendOTP,
                                                            children: "Resend OTP"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            style: {
                                border: "none",
                                borderRadius: "4px"
                            },
                            width: "100%",
                            py: "10px",
                            px: "24px",
                            fontSize: 14,
                            backgroundColor: formObject.duringOTP.buttonBackground,
                            roundness: (ref = props.storeInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.theme) === null || ref1 === void 0 ? void 0 : ref1.roundness,
                            disabled: formObject.duringOTP.isButtonDisable,
                            onClick: function() {
                                return formObject.duringOTP.submitVerifyOTP();
                            },
                            label: "Verify OTP"
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        !props.sendOTPBeforeHand ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "flex justify-end closeicon",
                            onClick: props.activeCloseFunction,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                loading: "lazy",
                                src: "https://cdn.dotpe.in/longtail/themes/8073865/9sE359Sh.webp",
                                alt: "cancel"
                            })
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-column",
                            style: {
                                gap: "32px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "form-header flex flex-column",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: ((ref2 = props.storeInfo) === null || ref2 === void 0 ? void 0 : ref2.logo_image) || constants_images/* DEFAULT_SSR_IMAGE_URL */.a,
                                                alt: "logo",
                                                height: "80px",
                                                width: "80px"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "header-text flex flex-column",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "silver f20px fw5",
                                                    style: {
                                                        transform: "translateY(2px)"
                                                    },
                                                    children: [
                                                        "Welcome to ",
                                                        (ref3 = props.storeInfo) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.store_info) === null || ref4 === void 0 ? void 0 : ref4.name
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "f28px fw7",
                                                    children: "Login"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "form-container flex flex-column self-strech",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "form-group flex flex-column",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    className: "f14px fw6 silver",
                                                    children: formObject.preOTP.labelText
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    onFocus: Truecaller,
                                                    type: formObject.preOTP.inputType,
                                                    className: "bg-white form-control f14px",
                                                    value: formObject.preOTP.inputValue,
                                                    placeholder: formObject.preOTP.inputPlaceholder,
                                                    onChange: formObject.preOTP.inputChangeHandler
                                                })
                                            ]
                                        }),
                                        props.isLoginByMobileNumber && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-start",
                                            style: {
                                                gap: "8px",
                                                marginTop: "16px"
                                            },
                                            children: [
                                                props.showWhatsappCheckbox && /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "checkbox",
                                                    checked: props.whatsappConsent,
                                                    onChange: function(e) {
                                                        return props.setWhatsappConsent(e.target.checked);
                                                    },
                                                    style: {
                                                        marginTop: "4px",
                                                        width: "18px",
                                                        height: "18px",
                                                        flexShrink: 0
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "f14px fw4 silver",
                                                    style: {
                                                        color: "#000000",
                                                        lineHeight: "20px",
                                                        fontFamily: "Manrope",
                                                        fontWeight: "300"
                                                    },
                                                    children: [
                                                        "Yes, I accept the",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "#",
                                                            rel: "noopener noreferrer",
                                                            style: {
                                                                textDecoration: "underline",
                                                                color: "black"
                                                            },
                                                            onClick: handleTermsAndConditionsClick,
                                                            target: "_blank",
                                                            children: "terms and conditions"
                                                        }),
                                                        " ",
                                                        "and want to receive important information & updates on my WhatsApp/SMS"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            style: {
                                border: "none",
                                borderRadius: "4px"
                            },
                            roundness: (ref5 = props.storeInfo) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.theme) === null || ref6 === void 0 ? void 0 : ref6.roundness,
                            fluid: true,
                            width: "100%",
                            py: "10px",
                            px: "24px",
                            fontSize: 14,
                            backgroundColor: formObject.preOTP.buttonBackground,
                            disabled: formObject.preOTP.isButtonDisable,
                            onClick: function() {
                                return formObject.preOTP.clickHandler();
                            },
                            label: "Get OTP"
                        })
                    ]
                }),
                props.emailLoginFeatureStatus && props.indianMobileLoginFeatureStatus ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-center separator",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                    className: "line"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text",
                                    children: "OR"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                    className: "line"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-column w-100 additional-login-options",
                            children: props.indianMobileLoginFeatureStatus ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: "flex justify-center items-center email-login-button pointer",
                                onClick: props.toggleCurrentLoginType,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "flex-shrink-0 icon",
                                        src: formObject.toggleLoginButtonIcon
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "fw6 button-text",
                                        children: formObject.toggleLoginButtonText
                                    })
                                ]
                            }) : null
                        })
                    ]
                }) : null
            ]
        })
    });
};
var PremiumDesktopAuth = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var formObject = props.formObject, handleTermsAndConditionsClick = props.handleTermsAndConditionsClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        visible: props.isVisible,
        className: "bottom-modal",
        animation: "center",
        onClose: props.activeCloseFunction,
        closeMaskOnClick: false,
        customStyles: {
            padding: "32px 24px",
            maxHeight: "100%",
            overflow: "hidden"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "premium-auth-modal-wrap overflow-hidden",
            children: [
                props.OTPsent ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-column login-otp-number-wrap",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "f20px fw7 otp-header",
                                    children: " OTP sent to "
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex justify-between flex-wrap items-center contact-edit-btn-wrapper",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "f28px fw7",
                                            children: formObject.duringOTP.contact
                                        }),
                                        !props.prefilledPhone ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex pointer edit-btn",
                                            onClick: function() {
                                                return formObject.duringOTP.toggleOTPsent();
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: formObject.duringOTP.editIcon,
                                                    alt: "edit",
                                                    height: "18px",
                                                    width: "18px"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "f16px fw6",
                                                    children: formObject.duringOTP.editContactText
                                                })
                                            ]
                                        }) : null
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "otp-form-group form-group flex flex-column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-column input-resend-wrapper",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-column label-input-wrapper",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    className: "f14px fw6",
                                                    children: "Enter OTP"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                                    value: formObject.duringOTP.inputValue,
                                                    onChange: formObject.duringOTP.handleInputChange,
                                                    numInputs: 4,
                                                    separator: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: " "
                                                    }),
                                                    containerStyle: {
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "flex-start",
                                                        gap: "16px"
                                                    },
                                                    shouldAutoFocus: true,
                                                    inputStyle: {
                                                        display: "flex",
                                                        width: "100%",
                                                        height: "100%",
                                                        padding: "6px 12px",
                                                        gap: "10px",
                                                        borderRadius: 6,
                                                        flex: "1 0 0",
                                                        border: "1px solid #E9E9E9",
                                                        backgroundColor: "white"
                                                    },
                                                    isInputNum: true
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex justify-between message-resend-wrapper",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: props.invalidOtp ? {
                                                        color: "red"
                                                    } : {
                                                        visibility: "hidden"
                                                    },
                                                    children: "Invalid OTP"
                                                }),
                                                props.timer ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "timer db f16px fw4",
                                                    children: [
                                                        "Resend in ",
                                                        "0:".concat(props.timer)
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex justify-end f12px",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "blue fw6 f16px pointer",
                                                        onClick: formObject.duringOTP.resendOTP,
                                                        children: "Resend OTP"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    style: {
                                        border: "none",
                                        borderRadius: "4px"
                                    },
                                    width: "100%",
                                    py: "10px",
                                    px: "24px",
                                    fontSize: 14,
                                    backgroundColor: formObject.duringOTP.buttonBackground,
                                    roundness: (ref = props.storeInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.theme) === null || ref1 === void 0 ? void 0 : ref1.roundness,
                                    disabled: formObject.duringOTP.isButtonDisable,
                                    onClick: function() {
                                        return formObject.duringOTP.submitVerifyOTP();
                                    },
                                    label: "Verify OTP"
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "form-header flex flex-column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: ((ref2 = props.storeInfo) === null || ref2 === void 0 ? void 0 : ref2.logo_image) || constants_images/* DEFAULT_SSR_IMAGE_URL */.a,
                                        alt: "logo",
                                        height: "80px",
                                        width: "80px"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "header-text flex flex-column",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "silver f20px fw5",
                                            style: {
                                                transform: "translateY(2px)"
                                            },
                                            children: [
                                                "Welcome to ",
                                                (ref3 = props.storeInfo) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.store_info) === null || ref4 === void 0 ? void 0 : ref4.name
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "f28px fw7",
                                            children: "Login"
                                        })
                                    ]
                                })
                            ]
                        }),
                        !props.sendOTPBeforeHand ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "closeicon",
                            onClick: props.activeCloseFunction,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                loading: "lazy",
                                src: "https://cdn.dotpe.in/longtail/themes/8073865/9sE359Sh.webp",
                                alt: "cancel"
                            })
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "form-container flex flex-column self-strech",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "form-group flex flex-column",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            className: "f14px fw6 silver",
                                            children: formObject.preOTP.labelText
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: formObject.preOTP.inputType,
                                            className: "bg-white form-control f14px",
                                            value: formObject.preOTP.inputValue,
                                            placeholder: formObject.preOTP.inputPlaceholder,
                                            onChange: formObject.preOTP.inputChangeHandler
                                        })
                                    ]
                                }),
                                props.isLoginByMobileNumber && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-start",
                                    style: {
                                        gap: "8px",
                                        marginTop: "16px",
                                        marginBottom: "16px"
                                    },
                                    children: [
                                        props.showWhatsappCheckbox && /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "checkbox",
                                            checked: props.whatsappConsent,
                                            onChange: function(e) {
                                                return props.setWhatsappConsent(e.target.checked);
                                            },
                                            style: {
                                                marginTop: "4px",
                                                width: "18px",
                                                height: "18px",
                                                flexShrink: 0
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "f14px fw4 silver",
                                            style: {
                                                color: "#000000",
                                                lineHeight: "20px",
                                                fontFamily: "Manrope",
                                                fontWeight: "300"
                                            },
                                            children: [
                                                "Yes, I accept the",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "#",
                                                    rel: "noopener noreferrer",
                                                    style: {
                                                        textDecoration: "underline",
                                                        color: "black"
                                                    },
                                                    onClick: handleTermsAndConditionsClick,
                                                    target: "_blank",
                                                    children: "terms and conditions"
                                                }),
                                                " ",
                                                "and want to receive important information & updates on my WhatsApp/SMS"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    style: {
                                        border: "none",
                                        borderRadius: "4px"
                                    },
                                    roundness: (ref5 = props.storeInfo) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.theme) === null || ref6 === void 0 ? void 0 : ref6.roundness,
                                    width: "100%",
                                    py: "10px",
                                    px: "24px",
                                    fontSize: 14,
                                    backgroundColor: formObject.preOTP.buttonBackground,
                                    disabled: formObject.preOTP.isButtonDisable,
                                    onClick: function() {
                                        return formObject.preOTP.clickHandler();
                                    },
                                    label: "Get OTP"
                                })
                            ]
                        })
                    ]
                }),
                props.emailLoginFeatureStatus && props.indianMobileLoginFeatureStatus ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-center separator",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                    className: "line"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text",
                                    children: "OR"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                    className: "line"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-column w-100 additional-login-options",
                            children: props.indianMobileLoginFeatureStatus ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: "flex justify-center items-center email-login-button pointer",
                                onClick: props.toggleCurrentLoginType,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "flex-shrink-0 icon",
                                        src: formObject.toggleLoginButtonIcon
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "fw6 button-text",
                                        children: formObject.toggleLoginButtonText
                                    })
                                ]
                            }) : null
                        })
                    ]
                }) : null
            ]
        })
    });
};
/* harmony default export */ var AuthPopUp = (AuthModal);


/***/ }),

/***/ 807362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(147568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(414924);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(197582);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(368060);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(913886);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(186812);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(667294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(225617);
/* harmony import */ var src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(474151);
/* harmony import */ var src_utils_getDecryptedContactInfo__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(941905);









// import {
//   initiateOTPSend,
//   // initOTPless,
//   verifyOTPLess,
//   IINIT_OTP_SEND,
//   IINIT_VERIFY_OTP,
//   OTP_RESPONSE_TYPE,
//   RESPONSE_STATUS,
//   COUNTRY_CODE,
//   // removeOTPLessSDK,
// } from './useOtpLoginUtils';
// import { toastNotifyError, toastNotifySuccess } from 'src/components/Common/Toast';
// import { canUseOTPLessLogin } from 'src/constants/common';


// let verifyOTPConfigs: any = {};
var useAuthenticate = function(timeLimit) {
    var isLoggedIn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, merchantAuthFlow = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var generateOtp = function generateOtp() {
        if (!merchantAuthFlow) {
            if (isLoggedIn) {
                sendOtp();
            }
        } else {
            sendOtpMerchant();
        }
    };
    var getClevertapEventData = function getClevertapEventData(isEmailLogin, contact) {
        var ref;
        return {
            event_name: isLoggedIn ? "Cx_Delete" : "Cx_Login",
            data: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
                domain: storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.domain,
                page: window.location.href,
                device: _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__/* .deviceWidth */ .o <= _utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .MAX_MOBILE_WIDTH */ .Cf ? "Mobile" : "Desktop"
            }, isEmailLogin ? "cx_email" : "cx_phone", contact)
        };
    };
    var startTimer = function startTimer() {
        setTimeLeft(timeLimit);
        endTimer();
        timerId.current = setInterval(function() {
            return setTimeLeft(function(prevTime) {
                return --prevTime;
            });
        }, 1000);
    };
    var endTimer = function endTimer() {
        if (timerId.current) {
            clearInterval(timerId.current);
            timerId.current = null;
        }
    };
    var onOtpChange = function onOtpChange(e) {
        if (invalidOtp) {
            setInvalidOtp(false);
        }
        var value = e.target.value.trim();
        !isNaN(value) && value.length <= 4 && setOtp(value);
    };
    var onSendOtpSuccess = function onSendOtpSuccess() {
        setIsOtpSent(true);
        startTimer();
    };
    var sendOtpMerchant = function sendOtpMerchant() {
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .generateOTPMerchants */ .ec)(authToken, onSendOtpSuccess));
    };
    var verifyMerchantActionByOtp = function verifyMerchantActionByOtp(callback) {
        var payload = {
            otp: +otp,
            phone: (0,src_utils_getDecryptedContactInfo__WEBPACK_IMPORTED_MODULE_6__/* .getDecryptedContactInfo */ .D)(ownerPhone)
        };
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .verifyMerchantActionOtp */ .v6)(payload, callback));
    };
    var authToken = (0,src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_5__/* .useWidgetDndContextData */ .KX)().authToken;
    var ownerPhone = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        var ref, ref1, ref2;
        return (ref = state.storeReducer) === null || ref === void 0 ? void 0 : (ref1 = ref.store) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.owner) === null || ref2 === void 0 ? void 0 : ref2.phone;
    });
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), otp = ref[0], setOtp = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(timeLimit), timeLeft = ref1[0], setTimeLeft = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), invalidOtp = ref2[0], setInvalidOtp = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isOtpSent = ref3[0], setIsOtpSent = ref3[1];
    var ref4 = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        var ref;
        return {
            userData: ((ref = state.userReducer) === null || ref === void 0 ? void 0 : ref.data) || {},
            storeInfo: state.storeReducer.store || {}
        };
    }), _userData = ref4.userData, _email = _userData.email, email = _email === void 0 ? "" : _email, _phone = _userData.phone, phone = _phone === void 0 ? "" : _phone, storeInfo = ref4.storeInfo;
    var timerId = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    // useEffect(() => {
    //   if (merchantAuthFlow) return;
    //   // isUserCallbackExecuted is used as "ONETAP" event is fired multiple times in low network conditions (replicable on cart page)
    //   let isUserCallbackExecuted = false;
    //   if (canUseOTPLessLogin) {
    //     initOTPless(function onOTPVerificationComplete(userData) {
    //       if (
    //         userData?.responseType !== OTP_RESPONSE_TYPE.ONETAP ||
    //         isUserCallbackExecuted
    //       ) {
    //         return;
    //       }
    //       isUserCallbackExecuted = true;
    //       const { callback, isLoginAttempt, isRedirection, isEmailLogin, contact } =
    //         verifyOTPConfigs;
    //       const payload = {
    //         token: userData?.response?.token,
    //         source: 'cfe',
    //         [isEmailLogin ? 'email' : 'phone']: contact,
    //         clevertapEventData: getClevertapEventData(isEmailLogin, contact),
    //       };
    //       dispatch(
    //         verifyOTP(payload, router, isRedirection, callback, isLoginAttempt, false)
    //       );
    //     });
    //     return () => {
    //       removeOTPLessSDK();
    //       verifyOTPConfigs = {};
    //     };
    //   }
    // }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        generateOtp();
    }, [
        isLoggedIn,
        merchantAuthFlow
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (!timeLeft) {
            endTimer();
        }
    }, [
        timeLeft
    ]);
    function sendOtp() {
        return _sendOtp.apply(this, arguments);
    }
    function _sendOtp() {
        _sendOtp = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
            var contact, isEmailLogin, configArgs, data;
            var _arguments = arguments;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                contact = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : email || phone || "", isEmailLogin = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : !!email, configArgs = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : null;
                data = {
                    email: contact,
                    store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id
                };
                dispatch(isEmailLogin ? (0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .generateOTPforEmail */ .mQ)(data, (next_router__WEBPACK_IMPORTED_MODULE_2___default()), "web", null, onSendOtpSuccess) : (0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .generateOTP */ .P)(contact, (next_router__WEBPACK_IMPORTED_MODULE_2___default()), "web", null, onSendOtpSuccess));
                return [
                    2
                ];
            });
        // if (!canUseOTPLessLogin) {
        //   const data = {
        //     email: contact,
        //     store_id: storeInfo?.store_id,
        //   };
        //   dispatch(
        //     isEmailLogin
        //       ? generateOTPforEmail(data, router, 'web', null, onSendOtpSuccess)
        //       : generateOTP(contact, router, 'web', null, onSendOtpSuccess)
        //   );
        // } else {
        //   if (configArgs) {
        //     // These are required because the email already logged in the browser, gets directly to auto-verify state & executes the
        //     // onOTPVerificationComplete method, which requires these configs
        //     const [callback, isLoginAttempt, contact, isEmailLogin, isRedirection] =
        //       configArgs;
        //     verifyOTPConfigs = {
        //       callback,
        //       isLoginAttempt,
        //       contact,
        //       isEmailLogin,
        //       isRedirection,
        //     };
        //   }
        //   const payload: IINIT_OTP_SEND = {
        //     [isEmailLogin ? 'email' : 'phone']: contact,
        //     channel: isEmailLogin ? 'EMAIL' : 'PHONE',
        //     channelType: isEmailLogin ? 'EMAIL' : 'PHONE',
        //     countryCode: isEmailLogin ? '' : COUNTRY_CODE.INDIA,
        //   };
        //   initiateOTPSend(payload)
        //     ?.then((data) => {
        //       console.log('data:  ', data);
        //       if (data.responseType !== OTP_RESPONSE_TYPE.INITIATE) {
        //         return;
        //       }
        //       if (data.statusCode !== RESPONSE_STATUS.SUCCESS.CODE) {
        //         toastNotifyError(
        //           data.errorMessage || data?.response?.errorMessage || 'Please try again!'
        //         );
        //         return;
        //       }
        //       toastNotifySuccess('OTP sent Successfully');
        //       onSendOtpSuccess();
        //     })
        //     .catch((response) => toastNotifyError(response.errorMessage));
        // }
        });
        return _sendOtp.apply(this, arguments);
    }
    function verifyOtp(callback) {
        return _verifyOtp.apply(this, arguments);
    }
    function _verifyOtp() {
        _verifyOtp = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(callback) {
            var isLoginAttempt, contact, isEmailLogin, isRedirection, _obj, payload, verifyOtpFinal;
            var _arguments = arguments;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                isLoginAttempt = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false, contact = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : email || phone || "", isEmailLogin = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : !!email, isRedirection = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : false;
                payload = (_obj = {
                    otp: otp
                }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, isEmailLogin ? "email" : "phone", contact), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, "clevertapEventData", getClevertapEventData(isEmailLogin, contact)), _obj);
                verifyOtpFinal = isEmailLogin ? _redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .verifyOTPforEmail */ .i5 : _redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .verifyOTP */ .qD;
                dispatch(verifyOtpFinal(payload, (next_router__WEBPACK_IMPORTED_MODULE_2___default()), isRedirection, callback, isLoginAttempt));
                return [
                    2
                ];
            });
        // if (!canUseOTPLessLogin) {
        //   const payload = {
        //     otp: otp,
        //     [isEmailLogin ? 'email' : 'phone']: contact,
        //     clevertapEventData: getClevertapEventData(isEmailLogin, contact),
        //   };
        //   const verifyOtpFinal = isEmailLogin ? verifyOTPforEmail : verifyOTP;
        //   dispatch(verifyOtpFinal(payload, router, isRedirection, callback, isLoginAttempt));
        // } else {
        //   verifyOTPConfigs = {
        //     callback,
        //     isLoginAttempt,
        //     contact,
        //     isEmailLogin,
        //     isRedirection,
        //   };
        //   const payload: IINIT_VERIFY_OTP = {
        //     otp: otp,
        //     [isEmailLogin ? 'email' : 'phone']: contact,
        //     channel: isEmailLogin ? 'EMAIL' : 'PHONE',
        //   };
        //   verifyOTPLess(payload)
        //     ?.then((response) => {
        //       if (response?.statusCode !== RESPONSE_STATUS.SUCCESS.CODE) {
        //         callback?.(false);
        //         toastNotifyError(
        //           response?.errorMessage ||
        //             response?.response?.errorMessage ||
        //             'We ran into some issue. Please try again.'
        //         );
        //       }
        //     })
        //     .catch((response) => toastNotifyError(response.errorMessage));
        // }
        });
        return _verifyOtp.apply(this, arguments);
    }
    return {
        setOtp: setOtp,
        otp: otp,
        isOtpSent: isOtpSent,
        invalidOtp: invalidOtp,
        timeLeft: timeLeft,
        generateOtp: generateOtp,
        setIsOtpSent: setIsOtpSent,
        setTimeLeft: setTimeLeft,
        setInvalidOtp: setInvalidOtp,
        onOtpChange: onOtpChange,
        sendOtp: sendOtp,
        startTimer: startTimer,
        endTimer: endTimer,
        verifyOtp: verifyOtp,
        verifyMerchantActionByOtp: verifyMerchantActionByOtp
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useAuthenticate);


/***/ })

}]);